export default __webpack_public_path__ + "static/media/people.54c9d804.svg";